<template>
  <div class="grid w-full gap-20">
    <div class="grid gap-8">
      <h2 class="raw-heading-2">
        {{ i18n(title) }}
      </h2>
      <p class="mx-auto max-w-[44ch] text-balance">
        {{ i18n(body) }}
      </p>
    </div>

    <!-- Three columns at every tier: at phone width the media just gets smaller, which is
         why the padding and the label shrink with it. -->
    <div class="grid gap-8 sm:grid-cols-3 md:gap-16">
      <button
        v-for="card in IMPACT_NAVIGATION"
        :key="card.route"
        type="button"
        class="grid cursor-pointer justify-items-center gap-4 rounded-[28px] bg-[white]/40 p-8 transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] active:bg-[white]/75 md:p-16 md:hover:bg-[white]/75"
        @click="emit('start', card.route)"
      >
        <!-- Not `ImageFigure`: a `<figure>` is invalid inside a button. -->
        <RevIllustration
          :src="card.image"
          :width="900"
          :height="900"
          alt=""
          aria-hidden="true"
          loading="lazy"
          class="rounded-full aspect-square w-full object-cover"
        />
        <RevIllustration
          :src="card.icon"
          alt=""
          aria-hidden="true"
          :width="24"
          :height="24"
          class="mt-12"
        />
        <span class="raw-body-2 w-min whitespace-normal max-md:!text-[11px]">
          {{ i18n(card.label) }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import type { ModalRoute } from '~/scopes/campaign/const/config.const'
import { IMPACT_NAVIGATION } from '~/scopes/campaign/const/impact-navigation.const'
import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

defineProps<{
  title: I18nDescriptor
  body: I18nDescriptor
}>()
const emit = defineEmits<{ start: [route: ModalRoute] }>()

const i18n = useI18n()
</script>
